/** @file Hierarchy panel: the bone/slot tree of the open document (DocumentPanel shows the no-project note). */
import type { IDockviewPanelProps } from 'dockview-react';
import { DocumentPanel } from '../../forms/DocumentPanel';
import { HierarchyTree } from './HierarchyTree';

/** The tree remounts with the panel; its open rows are local state. */
export function HierarchyPanel({ api }: IDockviewPanelProps) {
  return <DocumentPanel api={api} view={(doc, t) => <HierarchyTree doc={doc} t={t} />} />;
}
